let activeCustomerId: string | null = null;

export function setApiCustomerId(customerId: string | null): void {
  activeCustomerId = customerId;
}

export function getApiCustomerId(): string | null {
  return activeCustomerId;
}
